<template>
  <input v-model="model" class="md-input" v-bind="attributes" v-on="listeners" @focus="onFocus" @blur="onBlur" />
</template>

<script>
import MdUuid from '../../core/utils/MdUuid';
import MdFieldMixin from '../MdFieldMixin';
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'MdInput',
  mixins: [MdFieldMixin],
  inject: ['MdField'],
  props: {
    id: {
      type: String,
      default: () => 'md-input-' + MdUuid(),
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  computed: {
    toggleType() {
      return this.MdField.togglePassword;
    },
    isPassword() {
      return this.type === 'password';
    },
    listeners() {
      var l = { ...this.$attrs };
      delete l.input;
      return l;
    },
  },
  watch: {
    type(type) {
      this.setPassword(this.isPassword);
    },
    toggleType(toggle) {
      if (toggle) {
        this.setTypeText();
      } else {
        this.setTypePassword();
      }
    },
  },
  created() {
    this.setPassword(this.isPassword);
  },
  beforeUnmount() {
    this.setPassword(false);
  },
  methods: {
    setPassword(state) {
      this.MdField.password = state;
      this.MdField.togglePassword = false;
    },
    setTypePassword() {
      this.$el.type = 'password';
    },
    setTypeText() {
      this.$el.type = 'text';
    },
  },
});
</script>
